import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class FacebookPixelService {
    viewContent(
        content_category: string,
        content_name: string,
        content_type: string,
        value: number,
        content_ids: string[],
        current_lesson?: string
    ): void {
        (window as any).fbq("track", "ViewContent", {
            content_category: content_category,
            content_name: content_name,
            content_type: content_type,
            value: value,
            current_lesson: current_lesson,
            content_ids: content_ids
        });
    }

    AddPaymentInfo(content_category: string, contents: any): void {
        (window as any).fbq("track", "AddPaymentInfo", {
            contents: contents,
            content_category: content_category
        });
    }

    CompleteRegistration(status: boolean, content_name: string, content: any): void {
        (window as any).fbq("track", "CompleteRegistration", {
            content_name: content_name,
            status: status,
            content: content
        });
    }

    Contact(): void {
        (window as any).fbq("track", "Contact");
    }

    InitiateCheckout(content_category: string, currency: string, value: number): void {
        (window as any).fbq("track", "InitiateCheckout", {
            content_category: content_category,
            currency: currency,
            value: value
        });
    }

    Purchase(content_name: string, content_type: string, currency: string, value: number, content: any): void {
        (window as any).fbq("track", "Purchase", {
            content_name: content_name,
            content_type: content_type,
            currency: currency,
            value: value,
            content: content
        });
    }

    Search(content_category: string, search_string: string, userEmail?: string): void {
        (window as any).fbq("track", "Search", {
            content_category: content_category,
            search_string: search_string,
            userEmail: userEmail
        });
    }

    freeCourseRegistration(courseName: string, courseId: string, email: string, userName: string): void {
        (window as any).fbq("trackCustom", "FreeCourseRegistration", {
            courseName: courseName,
            courseId: courseId,
            email: email,
            userName: userName
        });
    }

    Login(email: string, usernames: string[], name: string, mothod?: string): void {
        (window as any).fbq("trackCustom", "Login", {
            email: email,
            username: usernames,
            name: name,
            mothod: mothod
        });
    }
}
